import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { Producer } from "../../types/types";

export const useRefreshProducers = () => {
  const setProducers = useAppStore((store) => store.setProducers);

  const [{ response: producersData }, doFetchProducers] = useFetch("/directories/producers");

  useEffect(() => {
    let producers = producersData?.data as unknown as Producer[];
    if (producers) {
      setProducers(producers);
    }
  }, [producersData]);

  return doFetchProducers;
};
